import { coreApi } from './axios';

/** @param {number | undefined} companyId */
export async function listSystemConsoleParameters(companyId) {
  const params = companyId != null ? { company_id: companyId } : {};
  const { data } = await coreApi.get('/system-console/parameters', { params });
  return data;
}

/**
 * Параметры, сгруппированные по ``system_console.parameter_group`` с bounds
 * (min/max/regex/allowed_values) прямо в каждой строке — под редактор страницы
 * «Параметры» в системной консоли.
 * @param {number | undefined} companyId
 */
export async function listSystemConsoleParametersGrouped(companyId) {
  const params = companyId != null ? { company_id: companyId } : {};
  const { data } = await coreApi.get('/system-console/parameters/grouped', { params });
  return Array.isArray(data) ? data : [];
}

/** @param {string} key @param {unknown} valueJson @param {number | null | undefined} companyId */
export async function putSystemConsoleParameter(key, valueJson, companyId) {
  const body = { value_json: valueJson, company_id: companyId ?? null };
  const { data } = await coreApi.put(`/system-console/parameters/${encodeURIComponent(key)}`, body);
  return data;
}

/** @param {string} documentTypeCode */
export async function listWorkflowRuleSets(documentTypeCode) {
  const { data } = await coreApi.get(
    `/system-console/workflow-rule-sets/${encodeURIComponent(documentTypeCode)}`,
  );
  return data;
}

/**
 * @param {string} documentTypeCode
 * @param {object} policyJson
 * @param {number | null | undefined} companyId
 * @param {string | undefined} comment
 */
export async function createWorkflowRuleSetDraft(documentTypeCode, policyJson, companyId, comment) {
  const body = { policy_json: policyJson, company_id: companyId ?? null, comment: comment ?? null };
  const { data } = await coreApi.post(
    `/system-console/workflow-rule-sets/${encodeURIComponent(documentTypeCode)}`,
    body,
  );
  return data;
}

/** @param {number} ruleSetId */
export async function activateWorkflowRuleSet(ruleSetId) {
  const { data } = await coreApi.post(
    `/system-console/workflow-rule-sets/by-id/${ruleSetId}/activate`,
  );
  return data;
}

/**
 * Подробная карточка rule set с ``policy_json`` и контекстом источника политики
 * (``policy_source``, ``has_active_db_policy``, ``active_db_version``).
 * Остаётся только для read-only совместимости (audit/legacy); новые правки
 * идут через ``putWorkflowMatrix``.
 * @param {number} ruleSetId
 */
export async function getWorkflowRuleSet(ruleSetId) {
  const { data } = await coreApi.get(
    `/system-console/workflow-rule-sets/by-id/${ruleSetId}`,
  );
  return data;
}

/**
 * Список типов документов, для которых настроена матрица переходов.
 * Используется левой панелью TransitionsMatrixModule.
 */
export async function listWorkflowDocumentTypes() {
  const { data } = await coreApi.get('/system-console/workflow/document-types');
  return Array.isArray(data) ? data : [];
}

/**
 * Полный граф статусов/переходов/действий для типа документа.
 * @param {string} documentTypeCode
 */
export async function getWorkflowMatrix(documentTypeCode) {
  const { data } = await coreApi.get(
    `/system-console/workflow/${encodeURIComponent(documentTypeCode)}/matrix`,
  );
  return data;
}

/**
 * Сохранить матрицу: валидирует payload, создаёт новую активную версию
 * rule set, перезаписывает actions/paths и обновляет метаданные статусов.
 * @param {string} documentTypeCode
 * @param {object} payload см. MatrixPayload
 */
export async function putWorkflowMatrix(documentTypeCode, payload) {
  const { data } = await coreApi.put(
    `/system-console/workflow/${encodeURIComponent(documentTypeCode)}/matrix`,
    payload,
  );
  return data;
}

/**
 * Облегчённый runtime-вариант графа для фронтовой breadcrumb
 * (без админ-полей). Доступен всем авторизованным пользователям.
 * @param {string} documentTypeCode
 */
export async function getWorkflowRuntime(documentTypeCode) {
  const { data } = await coreApi.get(
    `/system-console/workflow/${encodeURIComponent(documentTypeCode)}/runtime`,
  );
  return data;
}

/** @param {string} typeUid @param {string} name */
export async function patchStockDocumentTypeName(typeUid, name) {
  const { data } = await coreApi.patch(
    `/system-console/stock-document-types/${encodeURIComponent(typeUid)}/name`,
    { name },
  );
  return data;
}

/** @param {string} statusUid @param {string} name */
export async function patchStockDocumentStatusName(statusUid, name) {
  const { data } = await coreApi.patch(
    `/system-console/stock-document-statuses/${encodeURIComponent(statusUid)}/name`,
    { name },
  );
  return data;
}
